module.exports = __webpack_public_path__ + "img/recharge(6).31f3bc6a.png";